import {TransportCardInfoNew} from '../../../../shared/models/api/transportCardInfoNew';
import {AppThunk} from '../../index';
import {stateProgramSlice} from '../../../reducers/socialSupport/statePrograms';
import {httpService, HttpWrapperOptions} from '../../../../shared/httpWrapper';
import {getApiRoute} from '../../../../shared/pipes';
import {apiUrls} from '../../../../shared/constants/urls';
import {cardInfoNewSlice} from '../../../reducers/transportCard/cardInfoNew';
import {getTransportCardNumber} from '../../../../shared/utils/card';
import {SnackbarNotificationType} from '../../../../shared/components/snackbar/model';
import {addNotification} from '../../snackbar';
import {ServerValidationError} from '../../../../shared/models/serverValidationError';

export const setStatePrograms = stateProgramSlice.actions.setStatePrograms;

export const getTransportCardInfoNew = (cardNumber: number): AppThunk => {
  return async (dispatch) => {
    const options = new HttpWrapperOptions().ThrowException(true).Wait(true).Ignore401(true);
    options.apiServer = 'transportCard';

    try {
      const response = await httpService.get<TransportCardInfoNew>(
        getApiRoute(
          apiUrls.getTransportCardInfoNew,
          {cardNumber: getTransportCardNumber(cardNumber)},
          undefined,
          options.apiServer,
        ),
        options,
      );

      dispatch(cardInfoNewSlice.actions.setData(response));
    } catch (e) {
      const error = e as ServerValidationError;
      let errorText = error.data?.[0].message || error.message || 'Ошибка. Повторите еще раз';
      error.status !== 401 &&
        dispatch(
          addNotification({
            message: errorText,
            type: SnackbarNotificationType.Error,
          }),
        );
    } finally {
      dispatch(cardInfoNewSlice.actions.setLoaded(true));
    }
  };
};
